/** Portal SII (Maullín — ambiente de certificación): solicitud y descarga de folios para obtener el CAF XML. */
export const SII_SOLICITA_FOLIOS_URL =
  "https://maullin.sii.cl/cvc_cgi/dte/of_solicita_folios";

/**
 * Vista previa de un CAF XML (SII) en el navegador.
 * Alineado con `parseCafString` del backend (bloque <CAF>, TD, RE, D, H, FA).
 */
function extractFirst(xml, tagName) {
  const regex = new RegExp(`<${tagName}>([\\s\\S]*?)<\\/${tagName}>`);
  const match = xml.match(regex);
  return match ? match[1].trim() : "";
}

function extractSection(xml, tagName) {
  const regex = new RegExp(`<${tagName}(?:\\s+[^>]*)?>([\\s\\S]*?)<\\/${tagName}>`);
  const match = xml.match(regex);
  return match ? match[0] : "";
}

/**
 * @returns {{ ok: true, tipoDte, rutEmisor, folioDesde, folioHasta, fechaAutorizacion } | { ok: false, error: string }}
 */
export function parseCafXmlPreview(raw = "") {
  try {
    const cafXml = extractSection(raw, "CAF");
    if (!cafXml) {
      return {
        ok: false,
        error: "No se encontró un bloque <CAF> en el archivo (¿es el XML del SII?).",
      };
    }
    const td = Number(extractFirst(cafXml, "TD") || 0);
    const rutEmisor = extractFirst(cafXml, "RE");
    const d = Number(extractFirst(cafXml, "D") || 0);
    const h = Number(extractFirst(cafXml, "H") || 0);
    const fa = extractFirst(cafXml, "FA");
    if (!td || !rutEmisor || !Number.isFinite(d) || !Number.isFinite(h)) {
      return {
        ok: false,
        error:
          "El CAF no trae TD, RE o rango de folios (D/H) reconocibles en el XML.",
      };
    }
    return {
      ok: true,
      tipoDte: td,
      rutEmisor,
      folioDesde: d,
      folioHasta: h,
      fechaAutorizacion: fa || null,
    };
  } catch (e) {
    return {
      ok: false,
      error: e instanceof Error ? e.message : "No se pudo leer el XML.",
    };
  }
}

/** Nombres comunes SII (referencia; el CAF solo trae el código TD). */
export const DTE_TIPO_LABELS = {
  33: "Factura electrónica",
  34: "Factura exenta electrónica",
  39: "Boleta electrónica",
  41: "Boleta exenta electrónica",
  43: "Liquidación factura",
  45: "Factura de compra",
  46: "Factura de compra exenta",
  52: "Guía de despacho electrónica",
  56: "Nota de débito electrónica",
  60: "Liquidación",
  61: "Nota de crédito electrónica",
  110: "Exportación",
  111: "Boleto",
};

/** Opciones para filtros `<select>` (solo códigos conocidos; evita IDs arbitrarios). */
export const DTE_TIPO_FILTER_SELECT_OPTIONS = Object.entries(DTE_TIPO_LABELS)
  .map(([code, name]) => ({
    value: code,
    label: `${code} — ${name}`,
  }))
  .sort((a, b) => Number(a.value) - Number(b.value));

export function labelTipoDte(tipo) {
  const t = Number(tipo);
  return DTE_TIPO_LABELS[t] || `Documento tipo ${t}`;
}
